var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !!_vm.selectedChat
    ? _c(
        "div",
        { attrs: { id: "media-slide" } },
        [
          _c(
            "span",
            {
              staticClass: "material-icons media-btn",
              on: {
                click: function () {
                  return _vm.$emit("close-media-slide")
                },
              },
            },
            [_vm._v("arrow_back")]
          ),
          _vm._v(" "),
          _vm.selected === "all"
            ? _c("FilterTool", {
                attrs: {
                  id: "media-slide-filtre",
                  users: _vm.agents,
                  isGraphShowing: true,
                  "keep-state-on-query-params": true,
                },
                model: {
                  value: _vm.filters,
                  callback: function ($$v) {
                    _vm.filters = $$v
                  },
                  expression: "filters",
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "media-type" }, [
            _c(
              "span",
              {
                staticClass: "type",
                class: [_vm.filters.type === "image" && "selected-type"],
                on: { click: _vm.filterImages },
              },
              [_vm._v(_vm._s(_vm.$t("message.images")) + "\n        ")]
            ),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass: "type",
                class: _vm.filters.type === "file" && "selected-type",
                on: { click: _vm.filterFiles },
              },
              [_vm._v(_vm._s(_vm.$t("message.files")) + "\n        ")]
            ),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass: "type",
                class: _vm.filters.type === "url" && "selected-type",
                on: { click: _vm.filterURLs },
              },
              [_vm._v(_vm._s(_vm.$t("message.URLS")) + "\n        ")]
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { id: "media-slide-area" } },
            [
              _vm._l(_vm.getFilteredMessages(), function (message) {
                return _vm.messages.length > 0 && _vm.filters.type !== "url"
                  ? _c(
                      "span",
                      {
                        class: {
                          "chat-media-assets": _vm.filters.type === "file",
                          "chat-media-all": _vm.filters.type !== "file",
                        },
                      },
                      [
                        message.type === "image"
                          ? _c("ImageMessage", {
                              attrs: {
                                "extended-style": _vm.extendedStyle(),
                                message: message,
                                "message-colors": _vm.determineMessageColors(),
                              },
                            })
                          : message.type === "asset"
                          ? _c("AssetMessage", {
                              attrs: {
                                message: message,
                                "extended-style": _vm.extendedStyle(),
                                "message-colors": _vm.determineMessageColors(),
                                "is-filter-asset": _vm.filters.type === "file",
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    )
                  : _vm._e()
              }),
              _vm._v(" "),
              _vm.urlMessages.length > 0 && _vm.filters.type === "url"
                ? _c(
                    "span",
                    { attrs: { id: "url-message-wrapper" } },
                    _vm._l(
                      _vm.getFilteredLinkMessages(),
                      function (message, id) {
                        return _c("LinkMessage", {
                          key: id,
                          attrs: { message: message },
                        })
                      }
                    ),
                    1
                  )
                : _vm._e(),
            ],
            2
          ),
          _vm._v(" "),
          !_vm.getFilteredMessages().length &&
          !_vm.getFilteredLinkMessages().length
            ? _c("NoMessage", {
                attrs: {
                  title: _vm.$t("message.noMediaToShow"),
                  isGraphShowing: true,
                  "keep-state-on-query-params": true,
                },
              })
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }